<template lang="pug">
.home
  aside.aside
    .nav
      .system-name(@click="$router.push('/')") 南沙大桥
        span.span-heavy 坭洲水道桥
        span 除湿数据采集与监视控制系统
      .nav-bar
        .nav-buttom
          router-link(to="/niZhou/gasClamp") 主缆进排气
          router-link(to="/niZhou/prepStation1") 1号制备站
          router-link(to="/niZhou/prepStation2") 2号制备站
          router-link(to="/niZhou/prepStation3") 3号制备站
          router-link(to="/niZhou/prepStation4") 4号制备站
          router-link(to="/niZhou/prepStation5") 5号制备站
          router-link(to="/niZhou/prepStation6") 6号制备站
          router-link.same-line(to="/niZhou/bridgeImg") 
            p 全桥除湿
            p 总体布置图
          router-link(to="/nizhou/dataHistory?bridgeId=ffaa13fe-473e-4827-a8fd-b89b8fdd3899&scenarioId=TBD") 数据历史
  TimeBlock.time-block(bridgeName="GUANGDONG")
</template>

<script>
export default {
  name: "Index",
  data() {
    return {
      timer: null,
      bridgeId: "ffaa13fe-473e-4827-a8fd-b89b8fdd3899",
      historyScenarioList: [],
    };
  },
  mounted() {
    this.timer = setInterval(() => {
      this.checkAuth();
    }, this.REFRESH_SECOND);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  computed: {},
  methods: {
    checkAuth() {
      this.$http.get("/auth/LoginInfo").then((res) => {});
    },
  },
};
</script>
<style lang="scss" scoped>
.home {
  height: 100%;
  position: relative;
  background: url("../../assets/image/nizhou/nizhou.jpg") center no-repeat;
  background-size: cover;

  .time-block {
    position: absolute;
    top: 100px;
    right: 150px;
  }

  .aside {
    position: relative;
    width: 250px;
    height: 100%;
    color: #fff;
    min-width: 260px;
    text-align: center;
    box-shadow: 0 0 30px 0 #000;
    overflow: hidden;
    box-sizing: border-box;
    background: url("../../assets/image/nizhou/nizhou1.jpg") center no-repeat fixed;
    background-size: cover;

    ::-webkit-scrollbar {
      width: 8px;
      height: 8px;
      background: transparent;
    }

    ::-webkit-scrollbar-corner {
      background: transparent;
    }

    ::-webkit-scrollbar-thumb {
      border-radius: 5px;
      background-color: #84a4c2;
    }

    ::-webkit-scrollbar-track {
      box-shadow: inset 0 0 5px rgba(0, 0, 0, 0);
      border-radius: 0;
      background-color: transparent;
    }

    .nav {
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      right: 0;
      z-index: 1;

      a {
        display: block;
        width: 58%;
        height: 48px;
        margin: 0 auto 20px auto;
        border: none;
        line-height: 48px;
        border-radius: 5px;
        color: #4b4e50;
        background: #cadce9;
        cursor: pointer;
        text-decoration: none;

        &:hover {
          color: #fff;
          background: #33a2f5;
        }

        p {
          margin: 0;
        }

        &.same-line {
          display: flex;
          flex-direction: column;
          justify-content: center;
          line-height: 18px;
        }
      }

      .system-name {
        height: 75px;
        font-weight: 700;
        font-size: 35px;
        margin: 75px 0;
        cursor: pointer;
        span {
          display: block;
          font-size: 18px;
        }
        .span-heavy{
          font-size: 35px
        }
      }

      .nav-bar {
        height: calc(100% - 250px);
        overflow-y: auto;
      }
    }
  }
}
</style>
